import styled from '@emotion/styled';
import { Paper, type PaperProps } from '@mui/material';
import isPropValid from '@emotion/is-prop-valid';
import { alpha } from '@mui/material';
import { common } from '@mui/material/colors';
import mediaQuery from '@/lib/styling/mediaQuery';
import addBorderInHighContrastMode from '@/lib/styling/addBorderInHighContrastMode';

type CardWrapperProps = PaperProps & {
  contentVisibilityCompensationDistance: number;
};

const CardWrapper = styled(Paper, {
  shouldForwardProp: isPropValid,
})<CardWrapperProps>(
  ({ theme, contentVisibilityCompensationDistance }) => ({
    position: 'absolute',
    top: 0,
    left: `${contentVisibilityCompensationDistance}%`,
    width: 240,
    maxWidth: 'calc(20vw - 12px)',
    boxShadow: `0 6px 54px ${alpha(common.black, 0.34)}`,
    boxSizing: 'border-box',
    transition: theme.transitions.create('all'),
    transitionProperty: 'transform',
    [mediaQuery(700)]: {
      display: 'none',
    },
    // These styles will be countered by the appearance animation, which is
    // managed by the wrapper element
    transform: 'translateX(calc(-100% - 24px))',
    marginRight: 12,
    padding: 0,
    height: 0,
    opacity: 0,
    zIndex: -1,
  }),
  addBorderInHighContrastMode,
);

export default CardWrapper;
